// trends.js

// Import necessary libraries if needed
import Chart from 'chart.js/auto';

export function createMarketTrends(widget, data) {
  const avgListPrice = data.find(trend => trend.key === "avg_list_price").current;
  const formattedAvgListPrice = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(avgListPrice);
  widget.shadowRoot.querySelector('.alp-trend-value').innerHTML = formattedAvgListPrice;

  const avgSalePrice = data.find(trend => trend.key === "avg_sold_price").current;
  const formattedAvgSalePrice = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(avgSalePrice);
  widget.shadowRoot.querySelector('.asp-trend-value').innerHTML = formattedAvgSalePrice;

  const daysOnMarket = data.find(trend => trend.key === "days_on_market").current;
  const formattedDaysOnMarket = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(daysOnMarket);
  widget.shadowRoot.querySelector('.dom-trend-value').innerHTML = formattedDaysOnMarket;

  const homesSold = data.find(trend => trend.key === "homes_sold").current;
  const formattedHomesSold = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(homesSold);
  widget.shadowRoot.querySelector('.hs-trend-value').innerHTML = formattedHomesSold;

  const medListPrice = data.find(trend => trend.key === "med_list_price").current;
  const formattedMedListPrice = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(medListPrice);
  widget.shadowRoot.querySelector('.mlp-trend-value').innerHTML = formattedMedListPrice;

  const medSalePrice = data.find(trend => trend.key === "med_sold_price").current;
  const formattedMedSalePrice = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(medSalePrice);
  widget.shadowRoot.querySelector('.msp-trend-value').innerHTML = formattedMedSalePrice;

  const salesPriceRatio = data.find(trend => trend.key === "sale_price_ratio").current;
  const formattedSalesPriceRatio = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(salesPriceRatio);
  widget.shadowRoot.querySelector('.spr-trend-value').innerHTML = formattedSalesPriceRatio;

  const homesForSale = data.find(trend => trend.key === "homes_for_sale").current;
  const formattedHomesForSale = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(homesForSale);
  widget.shadowRoot.querySelector('.hfs-trend-value').innerHTML = formattedHomesForSale;
}

export function createPricesAndSalesGraph(widget, data) {
    const pricesAndSalesGraphElement = widget.shadowRoot.getElementById("pricesAndSalesGraph");
    pricesAndSalesGraphElement.classList.remove('d-none');
    new Chart(pricesAndSalesGraphElement, {
      type: 'line',
      data: {
        labels: data.map(a => {
          const date = new Date(a.period_name);
          const monthNames = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
          ];
          return `${monthNames[date.getMonth()]} ${date.getFullYear().toString().slice(-2)}`;
        }),
        datasets: [
          {
            label: 'Median Sale Price',
            data: data.map(a => a.median),
            borderWidth: 2,
            backgroundColor: widget.primaryColor,
            borderColor: widget.primaryColor,
            yAxisID: 'y',
          },
          {
            label: 'Average Sale Price',
            data: data.map(a => a.average),
            backgroundColor: widget.secondaryColor,
            borderColor: widget.secondaryColor,
            borderWidth: 2,
          },
        ]
      },
      options: {
        scales: {
          y: {
            beginAtZero: false
          },
        }
      }
    });
}

export function createDaysOnMarketGraph(widget, data) {
    const daysOnMarketGraphElement = widget.shadowRoot.getElementById("daysOnMarketGraph");
    daysOnMarketGraphElement.classList.remove('d-none');
    new Chart(daysOnMarketGraphElement, {
      type: 'line',
      data: {
        labels: data.map(a => {
          const date = new Date(a.period_name);
          const monthNames = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
          ];
          return `${monthNames[date.getMonth()]} ${date.getFullYear().toString().slice(-2)}`;
        }),
        datasets: [
          {
            label: 'Median Days on Market',
            data: data.map(a => a.median),
            borderWidth: 2,
            backgroundColor: widget.primaryColor,
            borderColor: widget.primaryColor,
            yAxisID: 'y',
          },
          {
            label: 'Average Days on Market',
            data: data.map(a => a.average),
            backgroundColor: widget.secondaryColor,
            borderColor: widget.secondaryColor,
            borderWidth: 2,
          }
        ]
      },
      options: {
        scales: {
          y: {
            beginAtZero: true
          }
        }
      }
    });
}

export function createDaysOfInventoryGraph(widget, inventoryData, priceData) {
    const daysOfInventoryGraphElement = widget.shadowRoot.getElementById("daysOfInventoryGraph");
    daysOfInventoryGraphElement.classList.remove('d-none');
    new Chart(daysOfInventoryGraphElement, {
      type: 'bar',
      data: {
        labels: inventoryData.map(a => {
          const date = new Date(a.period_name);
          const monthNames = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
          ];
          return `${monthNames[date.getMonth()]} ${date.getFullYear().toString().slice(-2)}`;
        }),
        datasets: [
          {
            label: 'Days of Inventory',
            data: inventoryData.map(a => a.days),
            borderWidth: 2,
            backgroundColor: widget.primaryColor,
            borderColor: widget.primaryColor,
            yAxisID: 'y',
          },
          {
            label: 'Homes Sold',
            data: priceData.map(a => a.sold),
            backgroundColor: widget.secondaryColor,
            borderColor: widget.secondaryColor,
            borderWidth: 2,
          }
        ]
      },
      options: {
        scales: {
          y: {
            beginAtZero: true
          }
        }
      }
    });
}
